import React from 'react';
import { Box, Tooltip, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronRight } from '@kula-ai/icons-core';
import { type DepartmentNode, getDepartmentPath } from './departmentPath';

interface DepartmentTreePopoverProps {
  department: DepartmentNode;
  allDepartments: DepartmentNode[];
  children: React.ReactNode;
}

export const DepartmentTreePopover: React.FC<DepartmentTreePopoverProps> = ({
  department,
  allDepartments,
  children,
}) => {
  const path = getDepartmentPath(department, allDepartments);
  const tooltipLabel = (
    <Flex alignItems="center" gap={1}>
      {path.map((node, index) => (
        <React.Fragment key={node.id}>
          {/* Inherit the tooltip's text colour: a fixed "white" token turns dark in dark mode. */}
          <KText fontSize="sm" color="inherit">
            {node.name}
          </KText>
          {index < path.length - 1 && (
            <ChevronRight color="currentColor" size={20} />
          )}
        </React.Fragment>
      ))}
    </Flex>
  );

  return (
    <Tooltip
      label={tooltipLabel}
      variant="default"
      placement="top-start"
      maxW="auto"
    >
      <Box display="inline-block">{children}</Box>
    </Tooltip>
  );
};
